/**
 * OPARA v7.0 - SEO Head Component
 * 
 * Manages meta tags for SEO and noindex for draft languages.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, getLanguageFromPath } from '../config/languages';

const SEOHead = () => {
  const location = useLocation();

  useEffect(() => {
    const langCode = getLanguageFromPath(location.pathname);
    const langConfig = SUPPORTED_LANGUAGES[langCode];

    // Update document direction for RTL languages
    document.documentElement.dir = langConfig?.dir || 'ltr';
    document.documentElement.lang = langCode;

    // Handle noindex for draft languages
    let robotsMeta = document.querySelector('meta[name="robots"]');
    
    if (langConfig?.noindex) {
      // Add noindex for draft languages
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.name = 'robots';
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.content = 'noindex, nofollow';
    } else {
      // Remove noindex for production languages
      if (robotsMeta) {
        robotsMeta.content = 'index, follow';
      }
    }

    // Update canonical URL based on language
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    
    const baseUrl = 'https://opara.co';
    if (langCode === 'en') {
      canonicalLink.href = `${baseUrl}${location.pathname}`;
    } else {
      canonicalLink.href = `${baseUrl}/${langCode}${location.pathname.replace(`/${langCode}`, '')}`;
    }

  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default SEOHead;
